// React
import React, { useState, useMemo, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

// Actions
import { getPickupAddress } from '../../../actions/user-service-action';

// Utils
import Loader from '../../Shared/Utils/Loader';
import { AddressCell, CustomHeader } from './utils';

// Components
import { ChartGrid } from '@mobilitystore/charts-interface';
import CapturePickupAddress from './capture-pickup-address';

// Css
import './index.scss';

const PickupAddress = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [pickupAddresses, setPickupAddresses] = useState([]);

  const dispatch = useDispatch();

  const { content, userCompanyStatus, isLoading } = useSelector((state) => ({
    content: state.ContentReducer.content,
    userCompanyStatus: state.CompanyDetailsReducer.userCompanyStatus,
    isLoading: state.OrderSummaryReducer?.isLoading
  }));

  const pickupAddressContent = content?.components?.my_profile?.pickup_address;

  useEffect(() => {
    displayPickupAddress();
  }, []);

  const displayPickupAddress = () => {
    dispatch(getPickupAddress(userCompanyStatus?.companyId)).then((response) => {
      setPickupAddresses(response);
    });
  };

  const handleOpenPopup = () => setShowPopup(true);

  const handleClosePopup = () => {
    setShowPopup(false);
    displayPickupAddress();
  };

  const colDefs = useMemo(
    () => [
      {
        field: 'address',
        headerName: 'Pickup Address',
        headerComponent: () => (
          <CustomHeader
            onAddClick={handleOpenPopup}
            title={pickupAddressContent?.title}
            button={pickupAddressContent?.button}
            icon='a-icon ui-ic-plus'
          />
        ),
        cellRenderer: (params) => <AddressCell params={params} />,
        flex: 1,
        suppressMenu: true,
        sortable: false,
        resizable: false
      }
    ],
    [pickupAddressContent, handleOpenPopup]
  );

  const gridProps = useMemo(
    () => ({
      rowData: pickupAddresses,
      columnDefs: colDefs,
      domLayout: 'autoHeight',
      rowHeight: 160,
      suppressMovableColumns: true,
      suppressRowSelection: true,
      onGridReady: (params) => {
        params.api.sizeColumnsToFit();
      },
      onFirstDataRendered: (params) => {
        params.api.sizeColumnsToFit();
      }
    }),
    [pickupAddresses, colDefs]
  );

  return (
    <div className='pickup-address'>
      {isLoading && <Loader />}
      <div className='pickup-address__grid-container'>
        <ChartGrid className='pickup-address__ag-table' gridProps={gridProps} />
      </div>

      {showPopup && <CapturePickupAddress onClose={handleClosePopup} />}
    </div>
  );
};

export default PickupAddress;
